var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7096c4375b9a13beb83417eefd57596b0300bf5c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"7096c4375b9a13beb83417eefd57596b0300bf5c"};
      